import { usePermissions } from "./PermissionsContext";

// Declarative gate. Renders children only when the current user has the
// requested permission. Supports both module-level and screen-level checks.
//
//   <Can module="employee" action="create">
//     <AddEmployeeButton />
//   </Can>
//
//   <Can module="employee" screen="employee_list" action="delete"
//        fallback={<DisabledButton />}>
//     <DeleteEmployeeButton />
//   </Can>
export default function Can({
  module: moduleKey,
  screen: screenKey,
  action = "view",
  children,
  fallback = null,
}) {
  const { hasModuleAccess, hasScreenAccess } = usePermissions();
  const allowed = screenKey
    ? hasScreenAccess(moduleKey, screenKey, action)
    : hasModuleAccess(moduleKey, action);
  return allowed ? children : fallback;
}
